import React from 'react';
import { Box, TextV2, Flex, ButtonV2, IconV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { CheckOutline } from '@withjoy/joykit/icons';
import { ReactComponent as Warning } from '@assets/icons/Error-32.svg';
import type { PayoutStatus } from './PayoutDialog.types';

interface StatusPayoutDialogProps {
  readonly onClose: () => void;
  readonly status: PayoutStatus;
  readonly onDone?: (status: PayoutStatus) => void;
}

export const StatusPayoutDialog: React.FC<StatusPayoutDialogProps> = ({ onClose, status, onDone }) => {
  const { tq } = useTranslation('cashFundsAdmin');
  return (
    <>
      <Flex
        justifyContent="center"
        marginBottom={8}
      >
        <TextV2 typographyVariant="display1">{tq`Transfer to Bank`}</TextV2>
      </Flex>

      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flex={1}
        marginBottom={8}
      >
        <Box
          borderStyle="solid"
          borderWidth="2px"
          borderColor="mono14"
          borderRadius="50%"
          width="56px"
          height="56px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginBottom={6}
        >
          <IconV2
            size="lg"
            color={status !== 'error' ? 'mono14' : 'negative6'}
          >
            {status !== 'error' ? <CheckOutline /> : <Warning />}
          </IconV2>
        </Box>
        <TextV2
          textAlign="center"
          typographyVariant="hed3"
          color="mono14"
        >
          {status !== 'error' ? tq`It's on its way.` : tq`Transfer Failed`}
        </TextV2>
        {status === 'error' && (
          <TextV2
            textAlign="center"
            typographyVariant="body3"
            color="mono12"
            marginTop={3}
          >
            {tq`We couldn't complete your transfer. Please contact support.`}
          </TextV2>
        )}
      </Flex>

      <ButtonV2
        onClick={() => {
          onDone?.(status);
          onClose();
        }}
        size="lg"
        intent="neutral"
        shape="rounded"
        fullWidth
      >
        {tq`Done`}
      </ButtonV2>
    </>
  );
};
